import Ipma from 'containers/ipma/Ipma';
import Dashboard from 'containers/ipma/Dashboard/Dashboard';
import Profile from 'containers/ipma/Profile/Profile';
import View from 'containers/ipma/Profile/View/View';
import Edit from 'containers/ipma/Profile/Edit/Edit';
import Add from 'containers/ipma/Add/Add';
import People from 'containers/ipma/People/People';
import Users from 'containers/ipma/People/Users/Users';
import Create from 'containers/ipma/Events/Create/Create';
import EventEdit from 'containers/ipma/Events/Edit/Edit';
import Events from 'containers/ipma/Events/Events';
import Ongoing from 'containers/ipma/Events/Ongoing/Ongoing';
import Completed from 'containers/ipma/Events/Completed/Completed';
import Cancelled from 'containers/ipma/Events/Cancelled/Cancelled';
import Duplicated from 'containers/ipma/Events/Duplicated/Duplicated';
import IssueBadge from 'containers/ipma/IssueBadge/IssueBadge';
import RegOffice from 'containers/ipma/RegOffice/RegOffice';
import CoursesProgrammes from 'containers/ipma/RegOffice/CoursesProgrammes/CoursesProgrammes';
import Waiting from 'containers/ipma/RegOffice/CoursesProgrammes/Waiting/Waiting';
import Accepted from 'containers/ipma/RegOffice/CoursesProgrammes/Accepted/Accepted';
import Rejected from 'containers/ipma/RegOffice/CoursesProgrammes/Rejected/Rejected';
import RegTable from 'containers/ipma/RegOffice/RegTable/RegTable';
import Awards from 'containers/ipma/Awards/Awards';
import IssueAward from 'containers/ipma/IssueAward/IssueAward';
import Reports from 'containers/ipma/Reports/Reports';
import ReadReport from 'containers/ma/Reports/ReadReport/ReadReport';
import Projects from '../containers/ipma/Projects/Projects';
import ProjectsPlanning from '../containers/ipma/Projects/Planning/Planning';
import ProjectsRunning from '../containers/ipma/Projects/Running/Running';
import ProjectsCompleted from '../containers/ipma/Projects/Completed/Completed';
import ProjectsCreate from '../containers/ipma/Projects/Create/Create';
import ProjectsEdit from '../containers/ipma/Projects/Edit/Edit';
import ProjectRoles from '../containers/ipma/ProjectRoles/ProjectRoles';
import ProjectRolesOpen from '../containers/ipma/ProjectRoles/Open/Open';
import ProjectRolesClosed from '../containers/ipma/ProjectRoles/Closed/Closed';
import ProjectRolesArchived from '../containers/ipma/ProjectRoles/Archived/Archived';
import ProjectRolesCreate from '../containers/ipma/ProjectRoles/Create/Create';
import ProjectRolesEdit from '../containers/ipma/ProjectRoles/Edit/Edit';
import Applications from '../containers/ipma/Applications/Applications';
import ApplicationsWaiting from '../containers/ipma/Applications/Waiting/Waiting';
import ApplicationsAccepted from '../containers/ipma/Applications/Accepted/Accepted';
import ApplicationsRejected from '../containers/ipma/Applications/Rejected/Rejected';
import ApplicationsAutoRejected from '../containers/ipma/Applications/AutoRejected/AutoRejected';
import ApplicationsOnHold from '../containers/ipma/Applications/OnHold/OnHold';
import Cis from '../containers/ipma/Cis/Cis';
import CisCvmb from '../containers/ipma/Cis-Cvmb/CisCvmb';
import Certificates from '../containers/ipma/Cis/Certificates/Certificates';
import AddCertificate from '../containers/ipma/Cis/Certificates/Add/AddCertificate';
import EditCertificate from '../containers/ipma/Cis/Certificates/Edit/EditCertificate';
import RenewCertificate from '../containers/ipma/Cis/Certificates/Renew/RenewCertificate';
import ExportCertificatesReport from '../containers/ipma/Cis/Certificates/ExportReport/ExportCertificatesReport';
import CertificateHolders from '../containers/ipma/Cis/CertificateHolders/CertificateHolders';
import AddCertificateHolder from '../containers/ipma/Cis/CertificateHolders/Add/AddCertificateHolder';
import EditCertificateHolder from '../containers/ipma/Cis/CertificateHolders/Edit/EditCertificateHolder';
import Invoices from '../containers/ipma/Cis/Invoices/Invoices';
import AddInvoice from '../containers/ipma/Cis/Invoices/Add/AddInvoice';
import EditInvoice from '../containers/ipma/Cis/Invoices/Edit/EditInvoice';
import Organizations from '../containers/ipma/Cis/Organizations/Organizations';
import AddOrganization from '../containers/ipma/Cis/Organizations/Add/AddOrganization';
import EditOrganization from '../containers/ipma/Cis/Organizations/Edit/EditOrganization';
import DeltaCertificates from '../containers/ipma/Cis/DeltaCertificates/DeltaCertificates';
import AddDeltaCertificate from '../containers/ipma/Cis/DeltaCertificates/Add/AddDeltaCertificate';
import EditDeltaCertificate from '../containers/ipma/Cis/DeltaCertificates/Edit/EditDeltaCertificate';
import RenewDeltaCertificate from '../containers/ipma/Cis/DeltaCertificates/Renew/RenewDeltaCertificate';
import Agreements from '../containers/ipma/Cis/Agreements/Agreements';
import AddAgreement from '../containers/ipma/Cis/Agreements/Add/AddAgreement';
import EditAgreement from '../containers/ipma/Cis/Agreements/Edit/EditAgreement';
import LevelDomains from '../containers/ipma/Cis/LevelDomains/LevelDomains';
import AddLevelDomain from '../containers/ipma/Cis/LevelDomains/Add/AddLevelDomain';
import EditLevelDomain from '../containers/ipma/Cis/LevelDomains/Edit/EditLevelDomain';
import CertificationBodies from '../containers/ipma/Cis/CertificationBodies/CertificationBodies';
import AddCertificationBody from '../containers/ipma/Cis/CertificationBodies/Add/AddCertificationBody';
import EditCertificationBody from '../containers/ipma/Cis/CertificationBodies/Edit/EditCertificationBody';
import CvmbReports from '../containers/ipma/Cis-Cvmb/CertificationReports/CertificationReports';
import Statistics from '../containers/ipma/Cis-Cvmb/Statistics/Statistics';
import ImportCertificateHolders from '../containers/ipma/Cis/CertificateHolders/Import/ImportCertificateHolder';
import StatisticsCertificates from '../containers/ipma/Cis-Cvmb/Certificates/Certificates';
import StatisticsForecasts from '../containers/ipma/Cis-Cvmb/Forecasts/Forecasts';
import StatisticsCertificateHolders from '../containers/ipma/Cis-Cvmb/CertificateHolders/CertificateHolders';
import CertificationReportForm from '../containers/ipma/Cis-Cvmb/CertificationReports/CertificationReportForm/CertificationReportForm';
import UnknownImports from '../containers/ipma/Cis/UnknownImports/UnknownImports';
import EditUnknownImports from '../containers/ipma/Cis/UnknownImports/Edit/EditUnknownImport';
import Assessors from '../containers/ipma/Cis/Assessors/Assessors';

const IPMA = 'ipmaBase';
const DASHBOARD = 'ipmaDashboard';
const PROFILE = 'ipmaProfile';
const PROFILE_EDIT = 'ipmaProfilEdit';
const PROFILE_VIEW = 'ipmaProfileView';
const PEOPLE = 'ipmaPeople';
const USERS_LIST = 'ipmaUsersList';
const PEOPLE_ADD = 'ipmaPeopleAdd';
const EVENTS = 'ipmaEvents';
const EVENTS_ONGOING = 'ipmaEventsOngoing';
const EVENTS_COMPLETED = 'ipmaEventsCompleted';
const EVENTS_CANCELLED = 'ipmaEventsCancelled';
const EVENTS_DUPLICATED = 'ipmaEventsDuplicated';
const EVENTS_CREATE = 'ipmaEventsCreate';
const EVENTS_EDIT = 'ipmaEventsEdit';
const EVENTS_ISSUE_BADGE = 'ipmaEventsIssueBadge';
const REG_OFFICE = 'ipmaRegOffice';
const REG_OFFICE_COURSES_PROGRAMMES = 'ipmaRegOfficeCoursesProgrammes';
const REG_OFFICE_COURSES_PROGRAMMES_WAITING = 'ipmaRegOfficeCoursesProgrammesWaiting';
const REG_OFFICE_COURSES_PROGRAMMES_ACCEPTED = 'ipmaRegOfficeCoursesProgrammesAccepted';
const REG_OFFICE_COURSES_PROGRAMMES_REJECTED = 'ipmaRegOfficeCoursesProgrammesRejected';
const REG_OFFICE_REG_TABLE = 'ipmaRegOfficeRegTable';
const AWARDS = 'ipmaAwards';
const ISSUE_AWARDS = 'ipmaIssueAward';
const REPORTS = 'ipmaReports';
const READ_REPORT = 'ipmaReadReport';
const PROJECTS = 'ipmaProjects';
const PROJECTS_PLANNING = 'ipmaProjectsPlaning';
const PROJECTS_RUNNING = 'ipmaProjectsRunning';
const PROJECTS_COMPLETED = 'ipmaProjectsCompleted';
const PROJECTS_CREATE = 'ipmaProjectsCreate';
const PROJECTS_EDIT = 'ipmaProjectsEdit';
const PROJECT_ROLES = 'ipmaProjectRoles';
const PROJECT_ROLES_OPEN = 'ipmaProjectRolesOpen';
const PROJECT_ROLES_CLOSED = 'ipmaProjectRolesClosed';
const PROJECT_ROLES_ARCHIVED = 'ipmaProjectRolesArchived';
const PROJECT_ROLES_CREATE = 'ipmaProjectRolesCreate';
const PROJECT_ROLES_EDIT = 'ipmaProjectRolesEdit';
const APPLICATIONS = 'ipmaApplications';
const APPLICATIONS_WAITING = 'ipmaApplicationsWaiting';
const APPLICATIONS_ACCEPTED = 'ipmaApplicationsAccepted';
const APPLICATIONS_REJECTED = 'ipmaApplicationsRejected';
const APPLICATIONS_AUTO_REJECTED = 'ipmaApplicationsAutoRejected';
const APPLICATIONS_ON_HOLD = 'ipmaApplicationsOnHold';
const CIS_CERTIFICATES = 'cisCertificates';
const CIS_CERTIFICATES_ADD = 'addCisCertificate';
const CIS_CERTIFICATES_EDIT = 'editCisCertificate';
const CIS_CERTIFICATES_RENEW = 'renewCisCertificate';
const CIS_DELTA_CERTIFICATES = 'cisDeltaCertificates';
const CIS_DELTA_CERTIFICATES_ADD = 'addCisDeltaCertificate';
const CIS_DELTA_CERTIFICATES_EDIT = 'editCisDeltaCertificate';
const CIS_DELTA_CERTIFICATES_RENEW = 'renewCisDeltaCertificate';
const CIS_CERTIFICATES_EXPORT_REPORT = 'exportCisCertificatesReport';
const CIS_CVMB_CERTIFICATES_EXPORT_REPORT = 'exportCisCvmbCertificatesReport';
const CIS_CERTIFICATE_HOLDERS = 'cisCertificateHolders';
const CIS_CERTIFICATE_HOLDERS_ADD = 'addCisCertificateHolders';
const CIS_CERTIFICATE_HOLDERS_EDIT = 'editCisCertificateHolders';
const CIS_INVOICES_ADD = 'cisInvoicesAdd';
const CIS_INVOICES_EDIT = 'cisInvoicesEdit';
const CIS_INVOICES = 'cisInvoices';
const CIS_AGREEMENTS_ADD = 'cisAgreementsAdd';
const CIS_AGREEMENTS_EDIT = 'cisAgreementsEdit';
const CIS_AGREEMENTS = 'cisAgreements';
const CIS_ORGANIZATIONS_ADD = 'addCisOrganization';
const CIS_ORGANIZATIONS_EDIT = 'editCisOrganization';
const CIS_ORGANIZATIONS = 'cisOrganizations';
const CIS = 'ssoCis';
const CIS_LEVEL_DOMAINS = 'cisLevelDomains';
const CIS_LEVEL_DOMAINS_ADD = 'addCisLevelDomain';
const CIS_LEVEL_DOMAINS_EDIT = 'editCisLevelDomain';
const CIS_CERTIFICATION_BODIES = 'cisCertificationBodies';
const CIS_CERTIFICATION_BODIES_ADD = 'addCisCertificationBody';
const CIS_CERTIFICATION_BODIES_EDIT = 'editCisCertificationBody';
const CIS_CVMB = 'cisCvmb';
const CIS_CVMB_REPORTS = 'cisCvmbReports';
const CIS_CVMB_REPORTS_EDIT = 'cisCvmbReportsEdit';
const CIS_CVMB_REPORTS_VIEW = 'cisCvmbReportsView';
const CIS_CVMB_STATISTICS = 'cisCvmbStatistics';
const CIS_CVMB_STATISTICS_CERTIFICATES = 'statisticsCertificates';
const CIS_CVMB_STATISTICS_FORECASTS = 'statisticsForecasts';
const CIS_CVMB_STATISTICS_CERTIFICATE_HOLDERS = 'statisticsCertificateHolders';
const CIS_CVMB_CERTIFICATION_BODIES = 'cisCvmbCertificationBodies';
const CIS_CERTIFICATE_HOLDERS_IMPORT = 'importCisCertificateHolders';
const CIS_IMPORTER_UNKNOWN = 'cisUnknownImports';
const CIS_IMPORTER_UNKNOWN_EDIT = 'cisUnknownImportsEdit';
const CIS_ASSESSORS = 'cisAssessors';

export default [
  {
    key: IPMA,
    path: '/ipma',
    component: Ipma,
    exact: false,
    withAuth: true,
    permissions: {
      appType: 'ipma',
    },
    routes: [
      {
        key: DASHBOARD,
        path: '/ipma',
        component: Dashboard,
        exact: true,
        withAuth: false,
      },
      {
        key: PROFILE,
        path: '/ipma/profile',
        component: Profile,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: PROFILE_VIEW,
            path: '/ipma/profile/view',
            component: View,
            exact: false,
            withAuth: false,
          },
          {
            key: PROFILE_EDIT,
            path: '/ipma/profile/edit',
            component: Edit,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_edit_profile'],
            },
          },
        ],
      },
      {
        key: PEOPLE_ADD,
        path: '/ipma/people/add',
        component: Add,
        exact: false,
        withAuth: false,
      },
      {
        key: PEOPLE,
        path: '/ipma/people',
        component: People,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: USERS_LIST,
            path: '/ipma/people/users',
            component: Users,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_manage_ipma_user_list'],
            },
          },
        ],
      },
      {
        key: CIS_CVMB,
        path: '/ipma/cvmb-cis',
        component: CisCvmb,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_cis_cvmb', 'ipma_cis_cvmb_read'],
        },
        routes: [
          {
            key: CIS_CVMB_REPORTS_EDIT,
            path: '/ipma/cvmb-cis/reports/edit',
            component: CertificationReportForm,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CVMB_REPORTS_VIEW,
            path: '/ipma/cvmb-cis/reports/view',
            component: CertificationReportForm,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CVMB_CERTIFICATES_EXPORT_REPORT,
            path: '/ipma/cvmb-cis/certificates/export-report',
            component: ExportCertificatesReport,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CVMB_CERTIFICATION_BODIES,
            path: '/ipma/cvmb-cis/certification-bodies',
            component: CertificationBodies,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CVMB_REPORTS,
            path: '/ipma/cvmb-cis/reports',
            component: CvmbReports,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CVMB_STATISTICS,
            path: '/ipma/cvmb-cis/statistics',
            component: Statistics,
            exact: false,
            withAuth: false,
            routes: [
              {
                key: CIS_CVMB_STATISTICS_CERTIFICATES,
                path: '/ipma/cvmb-cis/statistics/certificates',
                component: StatisticsCertificates,
                exact: false,
                withAuth: false,
              },
              {
                key: CIS_CVMB_STATISTICS_CERTIFICATE_HOLDERS,
                path: '/ipma/cvmb-cis/statistics/certificate-holders',
                component: StatisticsCertificateHolders,
                exact: false,
                withAuth: false,
              },
              {
                key: CIS_CVMB_STATISTICS_FORECASTS,
                path: '/ipma/cvmb-cis/statistics/forecasts',
                component: StatisticsForecasts,
                exact: false,
                withAuth: false,
              },
            ],
          },
        ],
      },
      {
        key: CIS,
        path: '/ipma/cis',
        component: Cis,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_cis', 'ipma_cis_lead'],
        },
        routes: [
          {
            key: CIS_CERTIFICATES_ADD,
            path: '/ipma/cis/certificates/create',
            component: AddCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATES_EDIT,
            path: '/ipma/cis/certificates/edit',
            component: EditCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATES_RENEW,
            path: '/ipma/cis/certificates/renew',
            component: RenewCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATES_EXPORT_REPORT,
            path: '/ipma/cis/certificates/export-report',
            component: ExportCertificatesReport,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATES,
            path: '/ipma/cis/certificates',
            component: Certificates,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_DELTA_CERTIFICATES_ADD,
            path: '/ipma/cis/delta-certificates/create',
            component: AddDeltaCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_DELTA_CERTIFICATES_EDIT,
            path: '/ipma/cis/delta-certificates/edit',
            component: EditDeltaCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_DELTA_CERTIFICATES_RENEW,
            path: '/ipma/cis/delta-certificates/renew',
            component: RenewDeltaCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_DELTA_CERTIFICATES,
            path: '/ipma/cis/delta-certificates',
            component: DeltaCertificates,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATE_HOLDERS_IMPORT,
            path: '/ipma/cis/certificate-holders/import',
            component: ImportCertificateHolders,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATE_HOLDERS_ADD,
            path: '/ipma/cis/certificate-holders/create',
            component: AddCertificateHolder,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATE_HOLDERS_EDIT,
            path: '/ipma/cis/certificate-holders/edit',
            component: EditCertificateHolder,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATE_HOLDERS,
            path: '/ipma/cis/certificate-holders',
            component: CertificateHolders,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_INVOICES_ADD,
            path: '/ipma/cis/invoices/create',
            component: AddInvoice,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_INVOICES_EDIT,
            path: '/ipma/cis/invoices/edit',
            component: EditInvoice,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_INVOICES,
            path: '/ipma/cis/invoices',
            component: Invoices,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_ORGANIZATIONS_ADD,
            path: '/ipma/cis/organizations/create',
            component: AddOrganization,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_ORGANIZATIONS_EDIT,
            path: '/ipma/cis/organizations/edit',
            component: EditOrganization,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_ORGANIZATIONS,
            path: '/ipma/cis/organizations',
            component: Organizations,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_AGREEMENTS_ADD,
            path: '/ipma/cis/agreements/create',
            component: AddAgreement,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_AGREEMENTS_EDIT,
            path: '/ipma/cis/agreements/edit',
            component: EditAgreement,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_AGREEMENTS,
            path: '/ipma/cis/agreements',
            component: Agreements,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_LEVEL_DOMAINS_ADD,
            path: '/ipma/cis/level-domains/create',
            component: AddLevelDomain,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_LEVEL_DOMAINS_EDIT,
            path: '/ipma/cis/level-domains/edit',
            component: EditLevelDomain,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_IMPORTER_UNKNOWN_EDIT,
            path: '/ipma/cis/unknown-imports/edit',
            component: EditUnknownImports,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_IMPORTER_UNKNOWN,
            path: '/ipma/cis/unknown-imports',
            component: UnknownImports,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_ASSESSORS,
            path: '/ipma/cis/assessors',
            component: Assessors,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_LEVEL_DOMAINS,
            path: '/ipma/cis/level-domains',
            component: LevelDomains,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATION_BODIES_ADD,
            path: '/ipma/cis/certification-bodies/create',
            component: AddCertificationBody,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATION_BODIES_EDIT,
            path: '/ipma/cis/certification-bodies/edit',
            component: EditCertificationBody,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ipma_cis'],
            },
          },
          {
            key: CIS_CERTIFICATION_BODIES,
            path: '/ipma/cis/certification-bodies',
            component: CertificationBodies,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: EVENTS,
        path: '/ipma/events',
        component: Events,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: EVENTS_ONGOING,
            path: '/ipma/events/ongoing',
            component: Ongoing,
            exact: false,
            withAuth: false,
          },
          {
            key: EVENTS_COMPLETED,
            path: '/ipma/events/completed',
            component: Completed,
            exact: false,
            withAuth: false,
          },
          {
            key: EVENTS_CANCELLED,
            path: '/ipma/events/cancelled',
            component: Cancelled,
            exact: false,
            withAuth: false,
          },
          {
            key: EVENTS_DUPLICATED,
            path: '/ipma/events/duplicated',
            component: Duplicated,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: EVENTS_CREATE,
        path: '/ipma/event/create/:id',
        component: Create,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_events_create_event'],
        },
      },
      {
        key: EVENTS_CREATE,
        path: '/ipma/event/create',
        component: Create,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_events_create_event'],
        },
      },
      {
        key: EVENTS_EDIT,
        path: '/ipma/event/:id/edit',
        component: EventEdit,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_events_edit_event'],
        },
      },
      {
        key: EVENTS_ISSUE_BADGE,
        path: '/ipma/event/:id/issue-badge',
        component: IssueBadge,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_events_issue_badge_event_list'],
        },
      },
      {
        key: REG_OFFICE,
        path: '/ipma/reg-office-hub',
        component: RegOffice,
        exact: false,
        withAuth: false,
      },
      {
        key: REG_OFFICE_COURSES_PROGRAMMES,
        path: '/ipma/reg-office/courses-programmes',
        component: CoursesProgrammes,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_manage_course'],
        },
        routes: [
          {
            key: REG_OFFICE_COURSES_PROGRAMMES_WAITING,
            path: '/ipma/reg-office/courses-programmes/waiting',
            component: Waiting,
            exact: false,
            withAuth: false,
          },
          {
            key: REG_OFFICE_COURSES_PROGRAMMES_ACCEPTED,
            path: '/ipma/reg-office/courses-programmes/accepted',
            component: Accepted,
            exact: false,
            withAuth: false,
          },
          {
            key: REG_OFFICE_COURSES_PROGRAMMES_REJECTED,
            path: '/ipma/reg-office/courses-programmes/rejected',
            component: Rejected,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: REG_OFFICE_REG_TABLE,
        path: '/ipma/reg-office-table',
        component: RegTable,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_manage_course'],
        },
      },
      {
        key: AWARDS,
        path: '/ipma/awards',
        component: Awards,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_award_issue_badge_award_list'],
        },
      },
      {
        key: ISSUE_AWARDS,
        path: '/ipma/award/:id/issue-badge',
        component: IssueAward,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_award_issue_badge_award_list'],
        },
      },
      {
        key: REPORTS,
        path: '/ipma/reports',
        component: Reports,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_ma_members_report'],
        },
      },
      {
        key: READ_REPORT,
        path: '/ipma/read-report/:id',
        component: ReadReport,
        exact: false,
        withAuth: false,
      },

      {
        key: PROJECTS,
        path: '/ipma/projects',
        component: Projects,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ipma_project_manage_project'],
        },
        routes: [
          {
            key: PROJECTS_PLANNING,
            path: '/ipma/projects/planning',
            component: ProjectsPlanning,
            exact: false,
            withAuth: false,
          },
          {
            key: PROJECTS_RUNNING,
            path: '/ipma/projects/running',
            component: ProjectsRunning,
            exact: false,
            withAuth: false,
          },
          {
            key: PROJECTS_COMPLETED,
            path: '/ipma/projects/completed',
            component: ProjectsCompleted,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: PROJECTS_CREATE,
        path: '/ipma/project/create',
        component: ProjectsCreate,
        exact: false,
        withAuth: false,
      },
      {
        key: PROJECTS_EDIT,
        path: '/ipma/project/:id/edit',
        component: ProjectsEdit,
        exact: false,
        withAuth: false,
      },
      {
        key: PROJECT_ROLES,
        path: '/ipma/project-roles/:id',
        component: ProjectRoles,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: PROJECT_ROLES_OPEN,
            path: '/ipma/project-roles/:id/open',
            component: ProjectRolesOpen,
            exact: false,
            withAuth: false,
          },
          {
            key: PROJECT_ROLES_CLOSED,
            path: '/ipma/project-roles/:id/closed',
            component: ProjectRolesClosed,
            exact: false,
            withAuth: false,
          },
          {
            key: PROJECT_ROLES_ARCHIVED,
            path: '/ipma/project-roles/:id/archived',
            component: ProjectRolesArchived,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: PROJECT_ROLES_CREATE,
        path: '/ipma/project-role/:id/create',
        component: ProjectRolesCreate,
        exact: false,
        withAuth: false,
      },
      {
        key: PROJECT_ROLES_EDIT,
        path: '/ipma/project-role/:id/edit/:roleId',
        component: ProjectRolesEdit,
        exact: false,
        withAuth: false,
      },
      {
        key: APPLICATIONS,
        path: '/ipma/applications/:id',
        component: Applications,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: APPLICATIONS_WAITING,
            path: '/ipma/applications/:id/waiting',
            component: ApplicationsWaiting,
            exact: false,
            withAuth: false,
          },
          {
            key: APPLICATIONS_ACCEPTED,
            path: '/ipma/applications/:id/accepted',
            component: ApplicationsAccepted,
            exact: false,
            withAuth: false,
          },
          {
            key: APPLICATIONS_REJECTED,
            path: '/ipma/applications/:id/rejected',
            component: ApplicationsRejected,
            exact: false,
            withAuth: false,
          },
          {
            key: APPLICATIONS_AUTO_REJECTED,
            path: '/ipma/applications/:id/auto-rejected',
            component: ApplicationsAutoRejected,
            exact: false,
            withAuth: false,
          },
          {
            key: APPLICATIONS_ON_HOLD,
            path: '/ipma/applications/:id/on-hold',
            component: ApplicationsOnHold,
            exact: false,
            withAuth: false,
          },
        ],
      },
    ],
  },
];
